import React, { useState } from 'react';
import { Chrome } from 'lucide-react';
import { toast } from 'sonner';

// Facebook icon component
const FacebookIcon = () => (
  <svg className="h-4 w-4 mr-2.5 opacity-80" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

export const SocialLoginButtons = () => {
  const [googleLoading, setGoogleLoading] = useState(false);
  const [facebookLoading, setFacebookLoading] = useState(false);

  const handleGoogleLogin = () => {
    setGoogleLoading(true);
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const handleFacebookLogin = async () => {
    setFacebookLoading(true);
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const redirectUrl = window.location.origin + '/auth/facebook/callback';
      
      // Get the Facebook OAuth URL from backend
      const response = await fetch(`${API_URL}/api/auth/facebook/login-url?redirect_uri=${encodeURIComponent(redirectUrl)}`);
      const data = await response.json();
      
      if (data.auth_url) {
        window.location.href = data.auth_url;
      } else {
        throw new Error('Failed to get Facebook login URL');
      }
    } catch (error) {
      console.error('Facebook login error:', error);
      toast.error('Facebook login is not available yet. Please use Google or email login.');
      setFacebookLoading(false);
    }
  };

  return (
    <div className="space-y-3">
      <button
        type="button"
        onClick={handleGoogleLogin}
        disabled={googleLoading || facebookLoading}
        className="w-full h-12 inline-flex items-center justify-center rounded-full border border-white/15 bg-transparent text-sm text-white hover:border-white/40 hover:bg-white/[0.03] disabled:opacity-50 transition-colors"
        data-testid="google-login-button"
      >
        <Chrome className="h-4 w-4 mr-2.5 opacity-80" />
        {googleLoading ? 'Redirecting…' : 'Continue with Google'}
      </button>

      <button
        type="button"
        onClick={handleFacebookLogin}
        disabled={googleLoading || facebookLoading}
        className="w-full h-12 inline-flex items-center justify-center rounded-full border border-white/15 bg-transparent text-sm text-white hover:border-white/40 hover:bg-white/[0.03] disabled:opacity-50 transition-colors"
        data-testid="facebook-login-button"
      >
        <FacebookIcon />
        {facebookLoading ? 'Redirecting…' : 'Continue with Facebook'}
      </button>
    </div>
  );
};